import Flickity from "flickity";

const sliders = document.querySelectorAll("[data-testimonial-slider]");
if (sliders.length) {
	for (const slider of sliders) {
		const flickity = new Flickity(slider, {
			// options
			contain: true,
			pageDots: true,
			freeScroll: true,
			wrapAround: true,
		});
	}
}

// import Flickity from "flickity";

// const sliders = document.querySelectorAll(".standardSlider");
// const mobSliders = document.querySelectorAll(".mobSlider");

// if (sliders) {
// 	sliders.forEach((item) => {
// 		let flky = new Flickity(item, {
// 			accessibility: true,
// 			prevNextButtons: true,
// 			pageDots: true,
// 			imagesLoaded: true,
// 		});

// 		window.addEventListener("load", () => {
// 			flky.resize();
// 		});
// 	});
// }

// if (mobSliders) {
// 	mobSliders.forEach((item) => {
// 		let flky = new Flickity(item, {
// 			accessibility: true,
// 			prevNextButtons: false,
// 			pageDots: false,
// 			imagesLoaded: true,
// 			cellAlign: "center",
// 			watchCSS: true,
// 		});

// 		window.addEventListener("load", () => {
// 			flky.resize();
// 		});
// 	});
// }
